module.exports = __webpack_public_path__ + "img/football 3.f453cae0.webp";